(
    function (skyward, $, undefined)
    {
        skyward.radioButtonGroup = skyward.radioButtonGroup || {};

        var initRadioButtonGroups = function (selector)
        {
            $(selector).find('.radioButtonGroup').each(function ()
            {
                var radioButtonGroup = $(this);
                var radioButtonGroupValue = radioButtonGroup.find('.radioButtonGroupValue');
                var name = radioButtonGroup.data().name;
                var radioButtonSelector = 'input:radio[name="' + name + 'child"]';
                var radioButtons = $(radioButtonSelector);

                var setDependencyAttributes = function ()
                {
                    var radioData = $(radioButtonSelector + ':checked').data();
                    for (var key in radioData)
                    {
                        if (key.lastIndexOf('dependencyattribute', 0) === 0)
                        {
                            skyward.controls.setDataAttribute(radioButtonGroupValue, key, radioData[key]);
                        }
                    }
                };
                setDependencyAttributes();

                radioButtons.on("change", function ()
                {
                    var button = $(this);
                    radioButtonGroup = button.parents(".radioButtonGroup");
                    radioButtonGroupValue = radioButtonGroup.find(".radioButtonGroupValue");
                    skyward.controls.setValue(radioButtonGroupValue, button.val());

                    setDependencyAttributes();
                });

                if (!radioButtonGroup.attr("aria-label") && !radioButtonGroup.attr("aria-labelledby"))
                {
                    const label = $.findLabel(name);
                    radioButtonGroup.attr("aria-labelledby", label.addIds().attr("id"));
                }
            });
        };

        var getRadioButtonObject = function (radioButtonGroup, radioButtonGroupValue, radioInputs)
        {
            var obj =
            {
                groupElement: radioButtonGroup,
                valueElement: radioButtonGroupValue,
                radioInputs: radioInputs,
                radioButtons: radioInputs.closest('.radioButton'),
                originalValue: radioButtonGroupValue.data().originalValue,
                getCheckedRadioButton: function ()
                {
                    return obj.radioInputs.filter(':checked');
                },
                getValue: function ()
                {
                    return obj.valueElement.val();
                }
            };

            return obj;
        };

        var getRadioButtonGroupElement = function (element)
        {
            if (element.hasClass('radioButtonGroup'))
            {
                return element;
            }

            return element.closest(".radioButtonGroup");
        };

        skyward.radioButtonGroup.getRadioButtonGroup = function (groupElement)
        {
            var radioButtonGroupValue = groupElement.find('.radioButtonGroupValue');
            var name = groupElement.data().name;
            var radioButtonSelector = 'input:radio[name="' + name + 'child"]';
            var radioButtons = $(radioButtonSelector);

            return getRadioButtonObject(groupElement, radioButtonGroupValue, radioButtons);
        };

        skyward.radioButtonGroup.enable = function (control)
        {
            var groupElement = getRadioButtonGroupElement(control);
            var group = skyward.radioButtonGroup.getRadioButtonGroup(groupElement);
            if (group)
            {
                skyward.controls.enable(group.radioInputs);
            }
        };

        skyward.radioButtonGroup.disable = function (control)
        {
            var groupElement = getRadioButtonGroupElement(control);
            var group = skyward.radioButtonGroup.getRadioButtonGroup(groupElement);
            if (group)
            {
                skyward.controls.disable(group.radioInputs);
            }
        };

        skyward.radioButtonGroup.hide = function (control)
        {
            var groupElement = getRadioButtonGroupElement(control);
            var group = skyward.radioButtonGroup.getRadioButtonGroup(groupElement);
            if (group)
            {
                group.radioButtons.hide();
            }
        };

        skyward.radioButtonGroup.show = function (control)
        {
            var groupElement = getRadioButtonGroupElement(control);
            var group = skyward.radioButtonGroup.getRadioButtonGroup(groupElement);
            if (group)
            {
                group.radioButtons.show();
                return group.radioButtons;
            }
            return $();
        };

        skyward.radioButtonGroup.getValue = function (control)
        {
            var groupElement = getRadioButtonGroupElement(control);
            var group = skyward.radioButtonGroup.getRadioButtonGroup(groupElement);
            if (group)
            {
                return group.getValue();
            }

            return undefined;
        };

        skyward.radioButtonGroup.getOriginalValue = function (control)
        {
            var groupElement = getRadioButtonGroupElement(control);
            var group = skyward.radioButtonGroup.getRadioButtonGroup(groupElement);
            if (group)
            {
                return group.originalValue;
            }

            return undefined;
        };

        skyward.radioButtonGroup.setValue = function (control, value, supressChangeEvent)
        {
            var groupElement = getRadioButtonGroupElement(control);
            var group = skyward.radioButtonGroup.getRadioButtonGroup(groupElement);
            if (group)
            {
                var checkedButtonValue = group.getCheckedRadioButton().val();
                if (checkedButtonValue != value)
                {
                    skyward.controls.setValue(group.radioInputs, value, supressChangeEvent);
                }

                group.valueElement.val(value);
                if (!supressChangeEvent)
                {
                    group.valueElement.change();
                }
            }
        };

        skyward.window.registerLoadDOMCallback(initRadioButtonGroups);

    }(window.skyward = window.skyward || {}, window.jQuery)
);